import { EditNotificationsOutlined } from "@mui/icons-material"
import { Box, Button, Typography, useTheme } from "@mui/material"
import { DataGrid, GridDeleteIcon } from "@mui/x-data-grid"
import { useEffect, useState } from "react"
import ConfirmationDialog from "../../components/ConfirmationDialog"
import Header from "../../components/Header"
import ProjectModuleApi from "../../services/api/ProjectModules"
import { tokens } from "../../theme"
import ProjectModuleForm from "./form"
import ProjectApi from "../../services/api/projects"
import ModuleCategoryApi from "../../services/api/moduleCategories"

const ProjectModules = () => {
	const theme = useTheme()
	const colors = tokens(theme.palette.mode)
	const projectModuleApi = ProjectModuleApi()
	const projectApi = ProjectApi()
	const moduleCategoryApi = ModuleCategoryApi()

	const [entitiesList, setEntitiesList] = useState([])
	const [projects, setProjects] = useState([])
	const [moduleCategories, setModuleCategories] = useState([])

	const [isConfirmationOpen, setConfirmationOpen] = useState(false)
	const [selectedId, setSelectedId] = useState("")
	const [editingEntity, setEditingEntity] = useState()

	const [open, setOpen] = useState(false)

	const columns = [
		{ field: "id", headerName: "ID" },
		{
			field: "projectName",
			headerName: "Project",
			flex: 1,
			cellClassName: "name-column--cell",
		},
		{
			field: "categoryName",
			headerName: "Category",
			flex: 1,
			cellClassName: "name-column--cell",
		},
		{
			field: "name",
			headerName: "Name",
			flex: 1,
			cellClassName: "name-column--cell",
		},
		{
			field: "path",
			headerName: "Path",
			flex: 1,
			cellClassName: "name-column--cell",
		},
		{
			field: "order_no",
			headerName: "Order Number",
		},
		{
			field: "",
			headerName: "Edit",
			flex: 1,
			renderCell: ({ row: { id } }) => {
				return (
					<Box display="flex" justifyContent="center" borderRadius="4px">
						<Typography
							variant="button"
							color="warning"
							onClick={() => editEntity(id)}
							style={{ cursor: "pointer", marginRight: "10px" }}
						>
							<EditNotificationsOutlined
								fontSize="small"
								style={{ marginRight: "4px" }}
							/>
							Edit
						</Typography>

						<Typography
							variant="button"
							color="error"
							onClick={() => deleteEntity(id)}
							style={{ cursor: "pointer" }}
						>
							<GridDeleteIcon fontSize="small" style={{ marginRight: "4px" }} />
							Delete
						</Typography>
					</Box>
				)
			},
		},
	]

	useEffect(() => {
		fetchProjects()
		fetchModuleCategories()
		fetchEntities()
	}, [])

	const fetchEntities = async () => {
		try {
			const data = await projectModuleApi.getAll()

			setEntitiesList(data.results)
		} catch (error) {
			console.log(fetchErrorMsg, error)
		}
	}

	const fetchProjects = async () => {
		try {
			const data = await projectApi.getAll()

			setProjects(data.results)
		} catch (error) {
			console.log(fetchErrorMsg, error)
		}
	}

	const fetchModuleCategories = async () => {
		try {
			const data = await moduleCategoryApi.getAll()

			setModuleCategories(data.results)
		} catch (error) {
			console.log(fetchErrorMsg, error)
		}
	}

	const editEntity = (id) => {
		setEditingEntity(entitiesList.find((row) => row.id === id))
		viewForm()
	}

	const deleteEntity = (id) => {
		setSelectedId(id)
		handleOpenConfirmation()
	}

	const handleOpenConfirmation = () => {
		setConfirmationOpen(true)
	}

	const handleCloseConfirmation = () => {
		setConfirmationOpen(false)
	}

	const handleConfirmAction = () => {
		try {
			const response = projectModuleApi.destroy(selectedId)

			console.log(deletedSuccessMsg, response)
			fetchEntities()
		} catch (error) {
			console.log(deleteErrorMsg, error)
		}

		handleCloseConfirmation()
	}

	const openCreateForm = () => {
		setEditingEntity()
		viewForm()
	}

	const viewForm = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
		fetchEntities()
	}

	return (
		<>
			<Box m="20px">
				<Header title={`${formName}s`} subtitle="" />

				<Box display="flex" justifyContent="end" m="0 0 0 0">
					<Button
						type="submit"
						color="secondary"
						variant="contained"
						onClick={openCreateForm}
					>
						{`Create ${formName}`}
					</Button>
				</Box>

				<Box
					m="40px 0 0 0"
					height="75vh"
					sx={{
						"& .MuiDataGrid-root": {
							border: "none",
						},
						"& .MuiDataGrid-cell": {
							borderBottom: "none",
						},
						"& .name-column--cell": {
							color: colors.greenAccent[300],
						},
						"& .MuiDataGrid-columnHeaders": {
							backgroundColor: colors.blueAccent[700],
							borderBottom: "none",
						},
						"& .MuiDataGrid-virtualScroller": {
							backgroundColor: colors.primary[400],
						},
						"& .MuiDataGrid-footerContainer": {
							borderTop: "none",
							backgroundColor: colors.blueAccent[700],
						},
						"& .MuiCheckbox-root": {
							color: `${colors.greenAccent[200]} !important`,
						},
					}}
				>
					<DataGrid rows={entitiesList} columns={columns} />
				</Box>
			</Box>

			<ConfirmationDialog
				open={isConfirmationOpen}
				onClose={handleCloseConfirmation}
				onConfirm={handleConfirmAction}
			/>

			<ProjectModuleForm
				formData={editingEntity}
				projects={projects}
				moduleCategories={moduleCategories}
				open={open}
				handleClose={() => handleClose()}
			/>
		</>
	)
}

const formName = "Project Module"
const deletedSuccessMsg = `${formName} deleted successfully: `
const deleteErrorMsg = `Not deleted ${formName}. `
const fetchErrorMsg = `Not loading ${formName}s`

export default ProjectModules
